import { useState } from 'react';
import styled from '@emotion/styled';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useTheme, Tooltip } from '@mui/material';

import { IconBox } from '../../Common';


const Container = styled.div`
`;

const InnerContainer = styled.div`
  /* position: absolute;
  top: -.3rem;
  left: 0; */
  position: relative;
  display: flex;
  flex-direction: column;
`;

const FloatingButton = styled(IconButton)`
  /* margin-bottom: 0.5rem; */
  /* width: 3rem; */
`;

const Options = styled.div`
  position: absolute;
  display: ${props => props.$open ? 'flex' : 'none'};
  flex-direction: ${props => props.$left ? 'row' : 'column'};
  gap: ${props => props.$left ? ".8rem" : ".3rem"};
  align-items: center;
  background-color: #fff;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 200;
  top: ${props => props.$left ? '-.4rem' : '3rem'};
  right: ${props => props.$left ? '3rem' : '-.3rem'};
  /* left: 0; */
  padding:  ${props => props.$left ? '.5rem 1rem' : '1rem .5rem'};
`;

const FloatingOptionsComponent = ({ actions = [], dir="left", id, url, row, idKey }) => {
  const [open, setOpen] = useState(false);
  const isLeft = dir === "left";

  const toggleOpen = () => {
    setOpen(prev => !prev);
  };

  const theme = useTheme();

  return (
    <Container>
      <InnerContainer>
        <FloatingButton onClick={toggleOpen} size='small' color="secondary">
          <MoreVertIcon fontSize='small' />
        </FloatingButton>

        <Options $left={isLeft} $open={open}>
        {actions.map(({tooltip, color, Icon, onClick, Component}) => ( Component ? <Component url={url} row={row} idKey={idKey} key={row[idKey]} /> :
          <Tooltip title={tooltip} key={tooltip}>
            <IconBox color={theme.palette.secondary.main} size="mini" bg={theme.palette.secondary.light} onClick={() => onClick(row[idKey], row)}>
              <Icon color="secondary" fontSize="small" />
            </IconBox>
          </Tooltip>
        ))}
        </Options>
      </InnerContainer>
    </Container>
  );
};

export default FloatingOptionsComponent;